import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";

export const useStyles = makeStyles(() => ({
  semesterList: {
    "& .MuiInputBase-root": {
      borderRadius: "40px",
      fontFamily: "inter !important",
    },
    "& .MuiInputBase-multiline": {
      borderRadius: "27px",
      fontFamily: "inter !important",
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      "& .MuiTableCell-root": {
        background: "#FEB62C",
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
    "& p": {
      fontFamily: "inter",
    },
  },
  error: {
    display: "flex",
    // justifyContent: "center",
    color: "red",
    fontSize: "12px",
  },
  selectError: {
    justifyContent: "center",
  },
  inputError: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgb(255 0 0 / 48%)",
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
    "& .MuiOutlinedInput-root:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
    "& .MuiSelect-root:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
  },
  formView: {
    flexDirection: "row !important",
    justifyContent: "space-between !important",
    alignItems: "center !important",
    margintBottom: "10px",
  },
  backArrow: {
    cursor: "pointer",
    fontFamily: "inter !important",
    color: `${color.black}`,
    fontSize: "16px",
  },
  title: {
    fontFamily: "inter !important",
    color: `${color.darkGreen}`,
    fontSize: "18px",
    fontWeight: 700,
  },
  input_label: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    color: "#222222",
  },
  submit_btn: {
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
  twoButtons: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  cancel_btn: {
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `${color.darkGrey} !important`,
    background: `${color.lightGrey} !important`,
  },
}));
